APP.header = function () {
	return true
}
